import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('RecoverPasswordApp => ');

const bootstrap = createAction('bootstrap form values', (userId, userEmail, isSupportUser) => ({
  userId,
  userEmail,
  isSupportUser,
}));
const updateField = createAction('update form values', (fieldId, value) => ({ fieldId, value }));

const onRecoverPasswordRequest = createAction('recover password request', (formRef, isValid) => ({ formRef, isValid }));
const onRecoverPasswordSuccess = createAction('recover password success');
const onRecoverPasswordFailure = createAction('recover password failure');

export default {
  bootstrap,
  updateField,

  onRecoverPasswordRequest,
  onRecoverPasswordSuccess,
  onRecoverPasswordFailure,
};
